import { Inject, Injectable } from '@angular/core';
import { SelectInputOptionInterface } from '@vendasta/galaxy/input';
import { combineLatest, EMPTY, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Market } from '../../../../core/markets/market';

@Injectable()
export class MarketDropdownService {
  readonly partnerHasOnlyOneMarket$ = this.markets$.pipe(map((markets) => markets.length === 1));

  readonly theOnlyMarketPartnerHas$: Observable<Market> = combineLatest([
    this.markets$,
    this.partnerHasOnlyOneMarket$,
  ]).pipe(
    switchMap(([markets, onlyOneMarket]) => {
      if (onlyOneMarket) {
        return of(markets[0]);
      }
      return EMPTY;
    }),
  );

  constructor(@Inject('markets$') readonly markets$: Observable<Market[]>) {}

  marketOptionsForSelectInput$: Observable<SelectInputOptionInterface[]> = this.markets$.pipe(
    map((markets) => markets.map((market) => this.mapMarketToOption(market))),
  );

  private mapMarketToOption(market: Market): SelectInputOptionInterface {
    return {
      label: market.name,
      value: market.market_id,
    } as SelectInputOptionInterface;
  }
}
